import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from "react-select";
import { getByDmService } from '../services/Api';


class AjaxSelect extends Component {
  static propTypes = {
    dataService: PropTypes.string,
    dataServiceParam: PropTypes.string,
    dataId: PropTypes.string,
    dataLabel: PropTypes.string,
  };

  static defaultProps = {
    dataService: null,
    dataServiceParam: "",
    dataId: "id",
    dataLabel: "nome",
  };

  constructor(props) {
    super(props);

    this.state = {
      options: [],
    };
  }

  componentWillUpdate = async(props) => {
    const {dataServiceParam} = this.props;
    if(props.dataServiceParam !== dataServiceParam) {
      await this.load();
    }
  }

  componentWillMount = async() => {
    await this.load();
  }

  load = async() => {
    try {
      const {dataId, dataLabel, dataService, dataServiceParam} = this.props;
      if(!dataService) console.error("the prop dataService is required");

      const data = await getByDmService(dataService, dataServiceParam || "");
      this.setState({
        options: data.map(item => ({ id: item[dataId || "id"], label: item[dataLabel || "nome"] }))
      });
    } catch (error) {
      console.error(error);
    }
  }

  render() {
    const {
      ...props
    } = this.props;
    const { options } = this.state;
    return (
      <Select
        options={options}
        {...props}
      />
    );
  }
}

export default AjaxSelect;



// WEBPACK FOOTER //
// ./src/components/AjaxSelect.js